<a
  [routerLink]="route()"
  class="tw-relative tw-flex tw-items-center tw-gap-2.5 tw-p-2 tw-rounded-lg tw-outline-none tw-no-underline hover:tw-bg-black/5 tw-transition-colors"
  [attr.aria-label]="label()"
  [title]="label()"
>
  <div class="tw-w-8 tw-h-8 tw-bg-[#0052cc] tw-rounded-lg tw-flex tw-items-center tw-justify-center tw-shrink-0 tw-shadow-sm" style="background-color: #0052cc !important;">
    <span class="p4y-badge-text" style="color: #ffffff !important; font-weight: 800 !important; font-size: 13px !important; line-height: 1 !important;">P4Y</span>
  </div>
  @if (sideNavService.open()) {
    <div class="tw-flex tw-flex-col">
      <span class="tw-text-base tw-font-bold tw-text-[#212529] tw-tracking-tight tw-leading-tight" style="color: #212529 !important;">Print4You</span>
      <span class="tw-text-[10px] tw-font-semibold tw-text-[#0052cc] tw-leading-tight" style="color: #0052cc !important;">{{ label() }}</span>
    </div>
  }
</a>
